// ── All Legal Events — global list ──
import { useState, useEffect } from "react";
import { localFilter, exportCSV, fmtDate } from "../../../shared/format";
import { Spinner, ErrorMsg, SectionHeader, SearchBar, Btn, Card, STh, Th, Td, Badge, Icon } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const AllLegalEventsPage = () => {
      const { api, setModal, role, setConfirm, delRec } = useApp();
      const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null);
      const [q,setQ]=useState("");
      const load=()=>{setLoading(true);api.get("getLegalEvents").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
      useEffect(()=>{load();},[]);
      const filtered=localFilter(rows,q,["type","companyname"]);
      const { sorted:displayed, sortKey, sortDir, toggle } = useSortable(filtered, 'startdate');

      if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
      return <>
        <SectionHeader actions={[
          <SearchBar key="s" value={q} onChange={setQ} placeholder="Search legal events..." />,
          <Btn key="ex" onClick={()=>exportCSV(filtered,["companyname","type","startdate","enddate"],"legal_events.csv")}>Export CSV</Btn>
        ]} />
        <Card><table style={{ width:"100%",borderCollapse:"collapse" }}>
          <thead><tr>
          <STh label="Account"    sortKey="companyname" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Type"       sortKey="type"        currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Start Date" sortKey="startdate"   currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="End Date"   sortKey="enddate"     currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <Th></Th>
        </tr></thead>
          <tbody>{displayed.map(e=>(
            <tr key={e.id} style={{ cursor:"pointer" }} onClick={()=>setModal({type:"legalevent-edit",rec:{...e,id:e.id,accountid:e.accountid},onDone:load})} onMouseEnter={ev=>ev.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
              <Td style={{ fontWeight:500 }}>{e.companyname||"—"}</Td>
              <Td><Badge s={e.type} /></Td>
              <Td>{fmtDate(e.startdate)}</Td>
              <Td>{e.enddate?fmtDate(e.enddate):"Ongoing"}</Td>
              <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={ev=>ev.stopPropagation()}>
                {role.canEdit&&<Btn onClick={()=>setModal({type:"legalevent-edit",rec:{...e,id:e.id,accountid:e.accountid},onDone:load})}><Icon type="edit" /></Btn>}
                {role.canDelete&&<Btn onClick={()=>setConfirm({msg:"Delete this legal event?",onConfirm:()=>delRec("LegalEvents",e.id,"Deleted legal event",load)})} variant="danger"><Icon type="delete" /></Btn>}
              </div></Td>
            </tr>
          ))}</tbody>
        </table></Card>
      </>;
    };
